import { useEffect } from 'react';

import { waitForAppReady, dispose as disposeApp } from './appContext';
import { init as initWindowController } from './windowController';

export const useApp = () => {
  useEffect(() => {
    // init window controller
    initWindowController();
    // init app
    waitForAppReady();

    return () => {
      disposeApp();
    };
  }, []);
};
